<template>
  <div class="input-group text">
    <div class="flex-start-end w-100">
      <div v-if="title" class="title flex-start-center">
        {{ title
        }}<span
          v-if="subTitle"
          class="sub-title"
          :class="subTitleAlignEnd ? 'flex-1 text-right mr-2px fs-16' : ''"
          :style="isSubTitleAlert ? 'color: red !important' : ''"
          >{{ subTitle }}</span
        >
        <div
          v-if="hasInstruction"
          class="flex-center-center ml-5px mt-2px cursor-pointer"
        >
          <img
            :src="$img.get('Icon/Question.svg')"
            alt=""
            @click="clickInstruction"
          />
        </div>
        <span v-if="isRequired" class="required">*</span>
      </div>
      <slot name="functionButtons"></slot>
    </div>
    <div class="input-text">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "title",
    "subTitle",
    "isSubTitleAlert",
    "subTitleAlignEnd",
    "isRequired",
    "hasInstruction",
  ],
  emits: ["clickInstruction"],
  methods: {
    clickInstruction() {
      this.$emit("clickInstruction", this.hasInstruction);
    },
  },
};
</script>

<style lange="scss" scoped>
.sub-title {
  font-size: 14px;
  color: #727272 !important;
}
</style>
